module.exports = __webpack_public_path__ + "static/media/Group 2813.335688c1.svg";